import { render, staticRenderFns } from "./orderAddress.vue?vue&type=template&id=20ab402b&scoped=true"
import script from "./orderAddress.vue?vue&type=script&lang=js"
export * from "./orderAddress.vue?vue&type=script&lang=js"
import style0 from "./orderAddress.vue?vue&type=style&index=0&id=20ab402b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab402b",
  null
  
)

export default component.exports